import React from 'react';
import {
    SelectField,
    Cell,
    TextField,
} from "react-md";
import { FiInfo } from "react-icons/fi"
import { Tooltip, IconButton, Typography } from "@mui/material"
import { BsInfoCircleFill } from "react-icons/bs";

const LabelPositionFields = ({
    id,
    showLabel,
    type,
    onTypeChange,

    xValue,
    onXValueChange,

    yValue,
    onYValueChange,
}) => {

    if (!showLabel) return null;
    return (
        <React.Fragment>
            <Cell size={3}>
                <div style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                }}>
                    <Tooltip
                        title={
                            <Typography className='text-white' fontSize={12}>
                                <div>
                                    Automatic - places the label at the vector's center point
                                </div>
                                <br />
                                <div>
                                    Automatic Flipped - same as Automatic, but positioned on the opposite side
                                </div>
                                <br />
                                <div>
                                    Manual - x and y positions are from the label's top-left corner; defaults to origin x and origin y
                                </div>
                            </Typography>
                        }>
                        <span style={{ cursor: "pointer", marginTop: "10px", marginRight: "8px" }}>
                            <BsInfoCircleFill color='#737373' />
                        </span>
                    </Tooltip>
                    <SelectField
                        fullWidth
                        helpText="Label Position Type"
                        id={`label-position-${id}`}
                        label="Label Position Type"
                        onChange={(value) => {
                            onTypeChange(value)
                        }}
                        menuItems={["Automatic", "Automatic Flipped", "Manual"]}
                        value={type}
                    />

                </div>
            </Cell>
            {type === "Manual" ?
                <Cell
                    size={6}
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "8px"
                    }}
                >
                    <TextField
                        id={`label-pos-x-${id}`}
                        placeholder="x"
                        label="Label X Position"
                        type="number"
                        value={xValue}
                        onChange={(value) => {
                            onXValueChange(value);
                        }}
                    />

                    <TextField
                        id={`label-pos-y-${id}`}
                        placeholder="y"
                        label="Label Y Position"
                        type="number"
                        value={yValue}
                        onChange={(value) => {
                            onYValueChange(value);
                        }}
                    />
                </Cell>
                : null}
        </React.Fragment>
    );
}

export default LabelPositionFields;
